import React from 'react'
import { useSelector } from 'react-redux'

const DashboardFilter = ({openFilterModal, filterPayload, handleFilterRemove, isTierRemovalRequired=false}) => {
    const { department } = useSelector((state) => state.department);
  return (
    <div className='d-flex justify-content-between align-items-center'>
        <div className="p-2 d-flex gap-1 w-75">
            {
                filterPayload?.searchStr &&
            <span className='fs-12px rounded-4 py-1 px-2 bg-white d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}>
                {filterPayload?.searchStr} 
                <button type="button" onClick={() => handleFilterRemove('searchStr')} className="icon-close_circle_stroke fs-16px" aria-label="Remove search string filter" style={{ background: 'none', border: 'none', padding: 0 }}></button>
                
            </span>
            }
            {
                filterPayload?.tier &&
            <span className='fs-12px rounded-4 py-1 px-2 bg-white d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}>
                {filterPayload?.tier} 
                {
                    isTierRemovalRequired &&
                    <button type="button" onClick={() => handleFilterRemove('tier')} className="icon-close_circle_stroke fs-16px" aria-label="Remove tier filter" style={{ background: 'none', border: 'none', padding: 0 }}></button>
                }
            </span>
            }
            {
                filterPayload?.department_id &&
            <span className='fs-12px rounded-4 py-1 px-2 bg-white d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}>
                {department?.find((e) => e.id === filterPayload?.department_id)?.name} 
                <button type="button" onClick={() => handleFilterRemove('department_id')} className="icon-close_circle_stroke fs-16px" aria-label="Remove department filter" style={{ background: 'none', border: 'none', padding: 0 }}></button>
            </span>
            }
        </div>

        {/* <div className="edit">
            <span className='fs-12px rounded-4 cursor-pointer py-1 px-2 d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}> 
            <i className='icon-published_with_changes fs-16px text-link'></i>
            <span className='text-link' onClick={()=>openFilterModal(true)} >Edit Filter</span> 
            
             </span>

        </div> */}
    </div>
  )
}

export default DashboardFilter
